import ModalApproval from "./ModalApproval";

export default ModalApproval;
